// extracted by mini-css-extract-plugin
module.exports = {"card":"desktopSliderCard_card__Llfit","cardDetails":"desktopSliderCard_cardDetails__NHD9K","title":"desktopSliderCard_title__834iT"};